import React, { useState } from 'react';

import { Box, Link, Typography } from '@mui/material';

import { GridView } from '../../common/components/GridView';
import { Resource } from '../../common/constants/resource';
import { DisclosureDetailColumnResolver } from '../detail/tasks/disclosure/DisclosureDetailColumnResolver';
import { DisclosureDetailColumns } from '../detail/tasks/disclosure/DisclosureDetailColumns';
import { DisclosureFactDetails } from '../tasks/types/disclosure';
import { Evidence } from '../tasks/types/evidence';
import styles from './styles.module.scss';

export const DisclosureDisplay = ({
  disclosureData,
}: {
  disclosureData: Evidence;
}) => {
  const disclosureDetail: DisclosureFactDetails | null = disclosureData
    ? (disclosureData.facts as DisclosureFactDetails)
    : null;

  const [showAllRules, setShowAllRules] = useState({
    isShowingAll: false,
  });
  const showMoreOrLess = () => {
    setShowAllRules({ isShowingAll: !showAllRules.isShowingAll });
  };

  return (
    <>
      {disclosureDetail?.facts?.length && (
        <>
          <Box
            my={1.5}
            display="flex"
            flexDirection="row"
            justifyContent="space-between"
            alignItems="center"
          >
            <Typography>{Resource.DISCLOSURE_SUBTITLE}</Typography>
            <Typography className={styles.RightEnd}>
              Showing{' '}
              {showAllRules.isShowingAll
                ? disclosureDetail.facts.length
                : Math.min(
                    Resource.DISCLOSURE_INITIAL_PAGE_SIZE,
                    disclosureDetail.facts.length,
                  )}{' '}
              of {disclosureDetail.facts.length}
            </Typography>
          </Box>

          <GridView
            rows={
              showAllRules.isShowingAll
                ? disclosureDetail.facts
                : disclosureDetail.facts.slice(
                    0,
                    Resource.DISCLOSURE_INITIAL_PAGE_SIZE,
                  )
            }
            columns={DisclosureDetailColumns}
            columnsResolver={DisclosureDetailColumnResolver}
            expandableRows={false}
          />
          {disclosureDetail.facts.length >
            Resource.DISCLOSURE_INITIAL_PAGE_SIZE && (
            <Box mt={1.5} className={styles.ShowMoreLess}>
              <Link onClick={showMoreOrLess}>
                {showAllRules.isShowingAll
                  ? Resource.DISCLOSURE_SHOW_LESS
                  : Resource.DISCLOSURE_SHOW_ALL}
              </Link>
            </Box>
          )}
        </>
      )}
    </>
  );
};
